import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { InputModal } from '../index'
import './InputStyle.scss'

const Input = ({
  value,
  placeholder,
  type,
  required,
  onChange,
  width,
  autoComplete,
  autoCompleteData,
  error,
  strictValidation,
}) => {
  const [modal, setModal] = useState(false)
  const [inputError, setInputError] = useState(false)

  return (
    <>
      <div role="button" onClick={() => setModal(true)} style={{ width }} className="styled-input">
        <input
          className={`${value ? 'success' : ''} ${inputError || (error && !value) ? 'error' : ''}`}
          type={type}
          value={value}
          placeholder={placeholder}
          readOnly
        />
        {value && !inputError && <img src="images/check.svg" alt="" />}
      </div>
      {modal && (
        <InputModal
          value={value}
          placeholder={placeholder}
          type={type}
          setValue={(content) => {
            onChange(content)
            if (!content && required) {
              setInputError(true)
            } else {
              setInputError(false)
            }
          }}
          closeModal={() => setModal(false)}
          autoCompleteList={autoComplete}
          autoCompleteData={autoCompleteData}
          strictValidation={strictValidation}
        />
      )}
    </>
  )
}

Input.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.string,
  autoComplete: PropTypes.bool,
  autoCompleteData: PropTypes.arrayOf(PropTypes.string),
  error: PropTypes.bool,
  strictValidation: PropTypes.bool,
}

Input.defaultProps = {
  value: '',
  required: false,
  width: 'fit-content',
  autoComplete: false,
  autoCompleteData: null,
  error: false,
  placeholder: '',
  strictValidation: false,
}

export default Input
